import http from '../http'
import {
  IRankingBoard,
  IRankingEventList,
  IMyRanking,
  IRankingEventNeighbor,
  IRankingButtonFlags,
} from 'adv-lib/src/v2/protocol/ranking-event'

export default class RankingEventApi {
  static async fetchRankingEventInfo(params: IRankingEventNeighbor.Params): Promise<IRankingEventNeighbor.Schema> {
    return http.get('rankingEvent/info', params)
  }

  static async fetchRankingButtonFlags(): Promise<IRankingButtonFlags.Schema> {
    return http.get('rankingEvent/buttonFlags', {})
  }

  static async fetchRankingEventList(params: IRankingEventList.Params): Promise<IRankingEventList.Schema> {
    return http.get('rankingEvent/list', params)
  }

  static async fetchRankingBoard(params: IRankingBoard.Params): Promise<IRankingBoard.Schema> {
    return http.get('rankingEvent/board', params)
  }

  static async fetchMyRanking(params: IMyRanking.Params): Promise<IMyRanking.Schema> {
    return http.get('rankingEvent/myRank', params)
  }
}
